import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createForm } from "rc-form";
import { useNavigate } from "react-router-dom";
import { selectIsLoading } from "../../redux/authentication/selectors";
import Theme from "../../theme";
import {
  Input,
  Box,
  Button,
  Spacer,
  Text,
  Grid,
  Checkbox,
} from "@flexisaf/flexibull2";
import { INSTITUTION_ID } from "../../utils/constants";
import { loginStart } from "../../redux/authentication/reducer";
import LoginLayout from "../../components/LoginLayout";

const Login = ({ form }) => {
  // const [loadingGoogleAuth, setLoadingGoogleAuth] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLoading = useSelector(selectIsLoading);
  const { getFieldError, getFieldProps, validateFields } = form;

  const handleLogin = () => {
    validateFields((err, values) => {
      if (!err) {
        let payload = {
          data: { institutionId: INSTITUTION_ID, ...values },
          callback: () => navigate("/dashboard"),
        };
        dispatch(loginStart(payload));
      }
    });
  };

  return (
    <LoginLayout>
      <Box pad="32px">
        <Box pad="24px" align="center">
          <Text block capitalize size="1.8rem">
            Login
          </Text>
        </Box>
        <Input
          type="text"
          required
          spaceBottom
          block
          placeholder="Username"
          error={getFieldError("username") ? "Username is required" : null}
          {...getFieldProps("username", {
            initialValue: "",
            rules: [{ required: true }],
          })}
        />
        <Input
          type={showPassword ? "text" : "password"}
          required
          block
          placeholder="Password"
          error={getFieldError("password") ? "password is required" : null}
          {...getFieldProps("password", {
            initialValue: "",
            rules: [{ required: true }],
          })}
        />
        <Grid responsive={false} default="auto max-content">
          <Box>
            <Checkbox
              label="Show Password"
              onChange={(e) => setShowPassword(e.target.checked)}
              checked={showPassword}
            />
          </Box>

          <Box pad="8px 0">
            <a href="/forgot-password">
              <Text
                style={{ cursor: "pointer" }}
                bold
                color={Theme.PrimaryColor}
              >
                Forgot Password
              </Text>
            </a>
          </Box>
        </Grid>
        <Spacer space="16px" />
        <Button
          disabled={isLoading}
          block
          onClick={handleLogin}
          progress={isLoading}
        >
          Login
        </Button>
        <Spacer space="16px" />
        <Button
          pale
          block
          // disabled={"loadingGoogleAuth" || "loading"}
          // onClick={logout}
          // loading={"loadingGoogleAuth"}
          iconLeft={
            <img
              alt="google signin"
              src="https://www.freepnglogos.com/uploads/google-logo-png/google-logo-png-google-icon-logo-png-transparent-svg-vector-bie-supply-14.png"
              style={{ height: "13px" }}
            />
          }
        >
          Sign in with Google
        </Button>
      </Box>
    </LoginLayout>
  );
};

export default createForm()(Login);
